import { defineComponent as _defineComponent } from 'vue'
import { EventData } from '@/models/Charts/chartsData';
import moment from 'moment';
import { loadScript } from '@/utils/misc';
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'EventDetails',
  props: {
    event: null
  },
  setup(__props: any) {

const props = __props as {
  event: EventData;
};

const DECISION_TREE_MARKER = 'decision tree tool';



const { t } = useI18n();

const decisionTreeId = ref<number | null>(null);
const decisionTreeIdRef = ref();

onMounted(() => {
  loadScript('https://zingtree.com/js/iframeResizerSmart.js');
});

function onManualDecisionTreeUpdate() {
  decisionTreeId.value = parseInt(decisionTreeIdRef.value.newValue, 10);
}

function getDecisionTreeId(): number | null {
  const matches = props.event.solution.match(/ID_(\d{9})/);
  if (matches === null) {
    return null;
  }
  return parseInt(matches[matches.length - 1], 10);
}

function formatDate(isoDate: string) {
  return moment(isoDate).format('YYYY-MM-DD, HH:mm:ss');
}

const hasDecisionTree = computed<boolean>(() =>
  props.event.solution.includes(DECISION_TREE_MARKER),
);

watch(
  props.event,
  () => {
    decisionTreeId.value = getDecisionTreeId();
  },
  { immediate: true },
);

return { __sfc: true,DECISION_TREE_MARKER, props, t, decisionTreeId, decisionTreeIdRef, onManualDecisionTreeUpdate, getDecisionTreeId, formatDate, hasDecisionTree }
}

})